import React from 'react';
import PropTypes from 'prop-types';
import Label from '../Label';
import { images } from '../../utils/icons';
import styles from './index.module.scss';
import serviceIcons from 'static/services.json';

//use icons from static file first
//if not available then use the icon images
const setIcon = name => {
  let img = '';
  if (typeof name === 'string') {
    img = serviceIcons.find(f => f.id === name);
    if (img) {
      return img?.icon;
    }
    img = images[name];
    if (typeof img === 'string') {
      return img;
    }
  }
  return img?.default;
};

const MultiIcon = props => {
  const { value: icons, label } = props;
  // check to see if the icon is a url
  const isApiIcon = icons?.includes('https');
  const arrayOfIcons = Array.isArray(icons);
  return (
    <span className={styles.iconContainer}>
      {arrayOfIcons ? (
        icons.length > 0 ? (
          icons.map((name, key) => {
            return (
              <Label
                className={styles.icon}
                icon={name?.icon ? name.icon : setIcon(name)}
                alt={typeof name === 'string' ? name : name?.name}
                key={key}
              />
            );
          })
        ) : (
          <div>-</div>
        )
      ) : (
        <Label
          icon={isApiIcon ? icons : icons === '-' ? '' : images[icons]?.default}
          label={label}
        />
      )}
    </span>
  );
};

MultiIcon.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
  label: PropTypes.string,
};

export default MultiIcon;
